var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import SelectDropdown from "../../../../../../shared-library/components/selectdropdown";
import { FileUploadSection, } from "@frameworks/web/components/fileupload/fileUploadSection";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import InputField from "@frameworks/web/components/generic/inputField";
import RadioButton from "@frameworks/web/components/generic/RadioButton/radioButton";
import di from "@frameworks/salesjourney/components/Features/ClientDetails/di/serviceLocator";
import { useSelector } from "react-redux";
import { CKYCFormData, CKYCinitResetFile, ICKYCFileUpload, keysNotCompulsoryCKYCForm, occupationType, radioTrueFalseData, residentialStatus, } from "./constants";
import { accountDetails } from "@salesdi";
var CKYCForm = function (props) {
    var _a = __read(useState(radioTrueFalseData[0]), 2), radioTrueFalse = _a[0], setradioTrueFalse = _a[1];
    var _b = __read(useState(CKYCinitResetFile), 2), resetFileUpload = _b[0], setResetFileUpload = _b[1];
    var _c = __read(React.useState([]), 2), countryDropDown = _c[0], setCountryDropdown = _c[1];
    var selectedAccount = useSelector(function (state) { return state.Clients.ClientSearch.reducersData.selected; });
    var _d = __read(useState(null), 2), ckycDetailsData = _d[0], setckycDetails = _d[1];
    var _e = __read(React.useState(CKYCFormData), 2), formData = _e[0], setFormData = _e[1];
    var getCountryDetails = function () {
        di.clients
            .getCountryCodeMasterData()
            .then(function (apiresponse) {
            if (apiresponse.length > 0) {
                var cName = apiresponse.map(function (item) {
                    return {
                        value: item.countryISOCode,
                        display: item.countryName,
                    };
                });
                setCountryDropdown(cName);
            }
        })
            .catch(function (error) {
            console.log("Failure", error.data);
        });
    };
    var getCKYCDetails = function () {
        di.clients
            .getCKYCDetails({ acCode: selectedAccount.accountCode })
            .then(function (val) {
            var MainVal = val[0];
            setckycDetails(MainVal);
            MainVal.Fatca == "Y"
                ? setradioTrueFalse(radioTrueFalseData[0])
                : setradioTrueFalse(radioTrueFalseData[1]);
            setFormData({
                FatherName: MainVal.FatherName,
                MotherName: MainVal.MotherName,
                ResidentStatus: MainVal.ResidentStatus,
                OccupationType: MainVal.OccupationType,
                address: "".concat(MainVal.Addr1, "  ").concat(MainVal.Addr2, "  ").concat(MainVal.Addr3),
                PinCode: MainVal.PinCode,
                City: MainVal.City,
                District: MainVal.District,
                State: MainVal.State,
                Country: MainVal.Country,
                FILE_passport: null,
                FILE_pan: null,
                FILE_Address_Proof: null,
            });
        });
    };
    var constructErrorChild = function (message) {
        return (React.createElement("div", { className: "DMSanN_16_400 txt_primaryGrey  mgb-5" }, message));
    };
    var matchErr = function () {
        var e_1, _a;
        try {
            for (var _b = __values(Object.entries(formData)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2), key = _d[0], val = _d[1];
                if (keysNotCompulsoryCKYCForm.includes(key))
                    continue;
                else if (!val) {
                    props.setckycFileUploadError(true);
                    props.setCKYCUploadErrorChild(constructErrorChild("".concat(key, " is required.")));
                    return true;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return false;
    };
    var saveCKYCDetails = function () { return __awaiter(void 0, void 0, void 0, function () {
        var payload;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!formData.FILE_passport ||
                        !formData.FILE_pan ||
                        !formData.FILE_Address_Proof) {
                        props.setckycFileUploadError(true);
                        props.setCKYCUploadErrorChild(constructErrorChild("Please Upload Proper Documents."));
                        return [2 /*return*/];
                    }
                    if (matchErr())
                        return [2 /*return*/];
                    if (formData.OccupationType ==
                        occupationType.find(function (x) { return x.value == "99"; }).value &&
                        !formData.Occupation) {
                        props.setckycFileUploadError(true);
                        props.setCKYCUploadErrorChild(constructErrorChild("Specify the occupation"));
                        return [2 /*return*/];
                    }
                    _a = {
                        acCode: selectedAccount.accountCode
                    };
                    return [4 /*yield*/, accountDetails.getSalesuserId()];
                case 1:
                    payload = (_a.userID = _b.sent(),
                        _a.fatca = radioTrueFalse.value,
                        _a.fatherName = formData.FatherName,
                        _a.motherName = formData.MotherName,
                        _a.residentStatus = formData.ResidentStatus,
                        _a.addr1 = formData.address,
                        _a.addr2 = "",
                        _a.addr3 = "",
                        _a.city = formData.City,
                        _a.pinCode = formData.PinCode,
                        _a.state = formData.State,
                        _a.country = formData.Country,
                        _a.occupationType = formData.OccupationType,
                        _a.occupation = (formData === null || formData === void 0 ? void 0 : formData.Occupation)
                            ? formData === null || formData === void 0 ? void 0 : formData.Occupation
                            : ckycDetailsData === null || ckycDetailsData === void 0 ? void 0 : ckycDetailsData.Occupation,
                        _a.district = formData.District,
                        _a.ckycFile = [
                            formData.FILE_passport[0].fileContent,
                            formData.FILE_passport[0].fileContent,
                            formData.FILE_passport[0].fileContent,
                        ],
                        _a.email = "",
                        _a.mobileNo = "",
                        _a.pan = "",
                        _a.acType = "",
                        _a.isAadhar = "",
                        _a.bankAccNo = "",
                        _a.bankName = "",
                        _a.neftCode = "",
                        _a.dP_Type = "",
                        _a.dP_Id = "",
                        _a.dP_Name = "",
                        _a.dP_AcNo = "",
                        _a.type = "",
                        _a.updateLink = "",
                        _a.firstName = "",
                        _a.birthDate = "",
                        _a.entity = "",
                        _a.isName = "",
                        _a.isEmail = "",
                        _a.isPan = "",
                        _a.isMobile = "",
                        _a.acName = "",
                        _a);
                    di.clients.saveCKYCDetails(payload).then(function (x) {
                        props.setckycSubmitSuccessFull(true);
                        resetCKYCForm();
                        getCKYCDetails();
                    });
                    return [2 /*return*/];
            }
        });
    }); };
    var handleChange = function (event) {
        var _a;
        setFormData(__assign(__assign({}, formData), (_a = {}, _a[event.currentTarget.name] = event.currentTarget.value, _a)));
    };
    useEffect(function () {
        getCountryDetails();
        if (selectedAccount === null || selectedAccount === void 0 ? void 0 : selectedAccount.accountCode)
            getCKYCDetails();
    }, [selectedAccount === null || selectedAccount === void 0 ? void 0 : selectedAccount.accountCode]);
    var resetCKYCForm = function () {
        setFormData(CKYCFormData);
        new Promise(function (resolve, reject) {
            setResetFileUpload({
                passportReset: true,
                panReset: true,
                addressReset: true,
            });
            setTimeout(resolve, 1000);
        }).then(function () {
            setResetFileUpload({
                passportReset: false,
                panReset: false,
                addressReset: false,
            });
        });
    };
    var defaultCountry = function () {
        var _a;
        if (countryDropDown && ckycDetailsData)
            return (_a = countryDropDown === null || countryDropDown === void 0 ? void 0 : countryDropDown.find(function (x) { return x.value === (ckycDetailsData === null || ckycDetailsData === void 0 ? void 0 : ckycDetailsData.Country); })) === null || _a === void 0 ? void 0 : _a.value;
        return undefined;
    };
    var fileSizeHelper = function (ckycFileType, reset, msg) {
        var _a, _b;
        props.setckycFileUploadError(true);
        props.setCKYCUploadErrorChild(constructErrorChild(msg));
        setResetFileUpload(__assign(__assign({}, resetFileUpload), (_a = {}, _a[reset] = true, _a)));
        setFormData(__assign(__assign({}, formData), (_b = {}, _b[ckycFileType] = null, _b)));
        return true;
    };
    var fileSizeError = function (ckycFileType, fileInfo) {
        if (ckycFileType === ICKYCFileUpload.FILE_pan && fileInfo.fileSize > 51200)
            return fileSizeHelper(ckycFileType, "panReset", "The File size approximately less than 50 KB for PAN");
        if (ckycFileType === ICKYCFileUpload.FILE_passport &&
            fileInfo.fileSize > 20480)
            return fileSizeHelper(ckycFileType, "passportReset", "The File size approximately less than 20 KB for PP sized Photograph");
        if (ckycFileType === ICKYCFileUpload.FILE_Address_Proof &&
            fileInfo.fileSize > 102400)
            return fileSizeHelper(ckycFileType, "addressReset", "The File size approximately less than 100 KB for Address Proof");
        return false;
    };
    var handleFileUpload = function (fileDetails, ckycFileType) {
        var _a, _b;
        var fileInfo = {
            fileContent: "",
            fileName: "",
            fileSize: 0,
        };
        if (fileDetails && fileDetails.docFile && fileDetails.base64Data) {
            fileInfo = {
                fileContent: fileDetails.base64Data.split(",")[1],
                fileName: fileDetails.docFile,
                fileSize: fileDetails.docFileSize,
            };
            if (fileSizeError(ckycFileType, fileInfo)) {
                setResetFileUpload(CKYCinitResetFile);
                return;
            }
            setFormData(__assign(__assign({}, formData), (_a = {}, _a[ckycFileType] = [fileInfo], _a)));
        }
        else
            setFormData(__assign(__assign({}, formData), (_b = {}, _b[ckycFileType] = null, _b)));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, { className: "outer-section p-30 mx-0" },
            React.createElement(Col, { lg: 12 },
                React.createElement("span", { className: "DMSanN_14_400 txt_primaryGrey" }, "FATCA Declaration is your Country of Birth, Nationality , Citizenship ,Tax Residency only India & no other country:")),
            React.createElement(Col, { lg: 12, className: "d-flex justify-content-start mt-2" }, radioTrueFalseData.map(function (radio) {
                return (React.createElement(RadioButton, { list: radio, name: "ckycForm", onChange: function (e) {
                        setradioTrueFalse(radio);
                    }, selected: radioTrueFalse.value, className: "common-radio-button" }));
            })),
            React.createElement(Col, { lg: 12, className: "grid-container-4-68 px-0 mt-30" },
                React.createElement("div", null,
                    React.createElement("label", { className: "DMSanN_16_400 txt_primaryGrey mgb-5" }, "Father's Name"),
                    React.createElement(InputField, { className: "RobotoM_16_500 txt_blackOne1", placeholderClassName: "", placeholder: "", name: "FatherName", onChangeEvent: handleChange, defaultValue: formData === null || formData === void 0 ? void 0 : formData.FatherName })),
                React.createElement("div", null,
                    React.createElement("label", { className: "DMSanN_16_400 txt_primaryGrey  mgb-5" }, "Mother's Name"),
                    React.createElement(InputField, { className: "RobotoM_16_500 txt_blackOne1", placeholderClassName: "", placeholder: "", name: "MotherName", onChangeEvent: handleChange, defaultValue: formData === null || formData === void 0 ? void 0 : formData.MotherName })),
                React.createElement("div", { className: " leadpage-selectdropdown" },
                    React.createElement("label", { className: "DMSanN_16_400 txt_primaryGrey  mgb-5" }, "Residential Status"),
                    React.createElement(SelectDropdown, { placeholder: "Select Residential Status", id: "residentialStatus", name: "ResidentStatus", selected: true, dropdownOptions: residentialStatus, required: true, downarrow: "edel-icon-arrow-down", placeholderClassName: "", onChangeEvent: handleChange, defaultValue: formData === null || formData === void 0 ? void 0 : formData.ResidentStatus })),
                React.createElement("div", { className: "leadpage-selectdropdown" },
                    React.createElement("label", { className: "DMSanN_16_400 txt_primaryGrey  mgb-5" }, "Occupation Type"),
                    React.createElement(SelectDropdown, { placeholder: "Select Occupation Type", id: "occupationType", name: "OccupationType", selected: true, dropdownOptions: occupationType, required: true, downarrow: "edel-icon-arrow-down", placeholderClassName: "", onChangeEvent: handleChange, defaultValue: formData === null || formData === void 0 ? void 0 : formData.OccupationType })),
                formData.OccupationType ==
                    occupationType.find(function (x) { return x.value == "99"; }).value && (React.createElement("div", null,
                    React.createElement("label", { className: "DMSanN_16_400 txt_primaryGrey mgb-5" }, "Specify"),
                    React.createElement(InputField, { className: "RobotoM_16_500 txt_blackOne1", placeholderClassName: "Specify", placeholder: "", name: "Occupation", onChangeEvent: handleChange, value: formData.Occupation })))),
            React.createElement(Col, { lg: 12, className: "grid-container-6-2-68 px-0 mt-30" },
                React.createElement("div", null,
                    React.createElement("label", { className: "DMSanN_16_400 txt_primaryGrey mgb-5" }, "Address"),
                    React.createElement(InputField, { className: "RobotoM_16_500 txt_blackOne1", placeholderClassName: "", placeholder: "", name: "address", onChangeEvent: handleChange, defaultValue: formData === null || formData === void 0 ? void 0 : formData.address })),
                React.createElement("div", null,
                    React.createElement("label", { className: "DMSanN_16_400 txt_primaryGrey  mgb-5" }, "Pin Code"),
                    React.createElement(InputField, { className: "RobotoM_16_500 txt_blackOne1", placeholderClassName: "", placeholder: "", name: "PinCode", onChangeEvent: handleChange, defaultValue: formData === null || formData === void 0 ? void 0 : formData.PinCode })),
                React.createElement("div", null,
                    React.createElement("label", { className: "DMSanN_16_400 txt_primaryGrey  mgb-5" }, "City"),
                    React.createElement(InputField, { className: "RobotoM_16_500 txt_blackOne1", placeholderClassName: "", placeholder: "", name: "City", onChangeEvent: handleChange, defaultValue: formData === null || formData === void 0 ? void 0 : formData.City }))),
            React.createElement(Col, { lg: 12, className: "grid-container-4-68 px-0 mt-30" },
                React.createElement("div", null,
                    React.createElement("label", { className: "DMSanN_16_400 txt_primaryGrey  mgb-5" }, "District"),
                    React.createElement(InputField, { className: "RobotoM_16_500 txt_blackOne1", placeholderClassName: "", placeholder: "", name: "District", onChangeEvent: handleChange, defaultValue: formData === null || formData === void 0 ? void 0 : formData.District })),
                React.createElement("div", { className: " leadpage-selectdropdown" },
                    React.createElement("label", { className: "DMSanN_16_400 txt_primaryGrey  mgb-5" }, "State"),
                    React.createElement(InputField, { className: "RobotoM_16_500 txt_blackOne1", placeholderClassName: "", placeholder: "", name: "State", onChangeEvent: handleChange, defaultValue: formData === null || formData === void 0 ? void 0 : formData.State })),
                React.createElement("div", { className: " leadpage-selectdropdown" },
                    React.createElement("label", { className: "DMSanN_16_400 txt_primaryGrey  mgb-5" }, "Country"),
                    React.createElement(SelectDropdown, { id: "countryName", name: "Country", dropdownOptions: countryDropDown, required: true, downarrow: "edel-icon-arrow-down", placeholderClassName: "", onChangeEvent: handleChange, defaultValue: defaultCountry() }))),
            React.createElement(Col, { lg: 12, className: "grid-container-4-68 px-0 mt-30 consent-fileupload-section common-fileupload-section" },
                React.createElement("div", null,
                    React.createElement("label", { className: "DMSanN_16_400 txt_primaryGrey  mgb-5" }, "PP Sized Photograph"),
                    React.createElement("div", { className: "d-feed-drag" },
                        React.createElement(FileUploadSection, { reset: resetFileUpload.passportReset, disableCross: false, fileType: ["jpg", "svg", "png"], onSubmit: function (fileinfo) {
                                return handleFileUpload(fileinfo, ICKYCFileUpload.FILE_passport);
                            }, id: "FILE_passport" }))),
                React.createElement("div", null,
                    React.createElement("label", { className: "DMSanN_16_400 txt_primaryGrey  mgb-5" }, "PAN"),
                    React.createElement("div", { className: "d-feed-drag" },
                        React.createElement(FileUploadSection, { reset: resetFileUpload.panReset, disableCross: false, fileType: ["jpg", "svg", "png"], onSubmit: function (fileinfo) {
                                return handleFileUpload(fileinfo, ICKYCFileUpload.FILE_pan);
                            }, id: "FILE_pan" }))),
                React.createElement("div", null,
                    React.createElement("label", { className: "DMSanN_16_400 txt_primaryGrey  mgb-5" }, "Address proof"),
                    React.createElement("div", { className: "d-feed-drag" },
                        React.createElement(FileUploadSection, { reset: resetFileUpload.addressReset, disableCross: false, fileType: ["jpg", "svg", "png"], onSubmit: function (fileinfo) {
                                return handleFileUpload(fileinfo, ICKYCFileUpload.FILE_Address_Proof);
                            }, id: "FILE_Address_Proof" })))),
            React.createElement(Col, { lg: 12, className: "mt-4" },
                React.createElement(Row, null,
                    React.createElement(Col, { lg: 6, className: "text-right" },
                        React.createElement(EdButton, { btnTyp: "midnight-blue", value: "Submit", onClick: function () { return saveCKYCDetails(); } })),
                    React.createElement(Col, { lg: 6 },
                        React.createElement(EdButton, { btnTyp: "midnight-blue-border", value: "Reset", onClick: function () { return resetCKYCForm(); } })))))));
};
export default CKYCForm;
